export const OPTION_TIME = 10;
export const LIVE_QUIZ_ID = 39;
